<template>
    <div class="pt-[20px] pr-[0px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <visaNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <FullButton
                width="100"
                title="Neue Abrechnung erfassen +"
                colour="white"
                data-cy="create_contact_button"
            />
            <h2 class="text-left text-2xl font-light my-[3%]">
                <strong>Abrechnungen in Bearbeitung</strong>
            </h2>
            <!-- import same structure as offers, but first setup stores -->
        </div>
    </div>
</template>

<script lang="ts" setup>
    import visaNavigation from '@/components/SubNavigations/TheVisaNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'

    //breadcrumbs
    const breadcrumbs = [
        {
            title: 'VISA',
            disabled: false,
            href: 'visa',
        },
    ]
</script>
